// 권한 관리 화면의 메뉴 묶음 (permission code 접두어 기준, 표시 순서)
export const PERMISSION_MENUS: { label: string; resources: string[] }[] = [
  { label: '행사', resources: ['event'] },
  { label: '행사 상세 관리', resources: ['enroll', 'enroll_response'] },
  { label: '피드백 템플릿', resources: ['feedback_template'] },
  { label: '추가정보 템플릿', resources: ['additional_template'] },
  { label: '콘텐츠', resources: ['content'] },
  { label: '컬렉션', resources: ['collection'] },
  { label: '파트너', resources: ['partner'] },
  { label: '알림센터', resources: ['push'] },
  { label: '홈', resources: ['home'] },
  { label: '퀵메뉴', resources: ['quick_menu'] },
  { label: '스티커', resources: ['sticker'] },
  { label: '회원', resources: ['user'] },
  { label: '회원 그룹', resources: ['user_group'] },
  { label: '조직', resources: ['org'] },
  { label: '어드민 계정', resources: ['admin'] },
  { label: '권한 관리', resources: ['role'] },
  { label: '조직 멤버', resources: ['org_member'] },
];

// 여러 리소스를 묶은 메뉴에서 구분이 필요한 항목 라벨
const CODE_LABEL_MAP: Record<string, string> = {
  'enroll:list': '신청자 목록',
  'enroll:update': '신청자 수정',
  'enroll:notify': '참여자 알림',
  'enroll:phone': '휴대폰번호 원문',
  'enroll_response:list': '추가정보 & 피드백 목록',
  'enroll_response:detail': '추가정보 & 피드백 상세',
  'enroll_response:update': '추가정보 & 피드백 수정',
};

const ACTION_LABEL_MAP: Record<string, string> = {
  list: '목록',
  detail: '상세',
  get: '조회',
  create: '생성',
  update: '수정',
  delete: '삭제',
  send: '발송',
  grant: '지급',
  block: '상태 변경',
  phone: '번호 원문',
  notify: '참여자 알림',
  invite: '부여',
  remove: '해제',
};

export function getActionLabel(code: string): string {
  if (CODE_LABEL_MAP[code]) return CODE_LABEL_MAP[code];
  const action = code.split(':')[1] ?? '';
  return ACTION_LABEL_MAP[action] ?? action;
}
